import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1883b6b8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "footer-col" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode("Home")
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("ul", null, null, -1))
const _hoisted_7 = { class: "footer-col" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("About")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("About Uber Sheep")
const _hoisted_10 = /*#__PURE__*/_createTextVNode("About Owner")
const _hoisted_11 = { class: "footer-col" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode("Music")
const _hoisted_13 = /*#__PURE__*/_createTextVNode("Original songs")
const _hoisted_14 = /*#__PURE__*/_createTextVNode("Original mini songs")
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Cover songs")
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<div class=\"footer-col\" data-v-1883b6b8><h4 data-v-1883b6b8>Follow Watame</h4><div class=\"social-links\" data-v-1883b6b8><a href=\"https://www.youtube.com/channel/UCqm3BQLlJfvkTsX_hvm0UmA\" target=\"_blank\" data-v-1883b6b8><i class=\"fab fa-youtube\" data-v-1883b6b8></i></a><a href=\"https://twitter.com/tsunomakiwatame\" target=\"_blank\" data-v-1883b6b8><i class=\"fab fa-twitter\" data-v-1883b6b8></i></a></div></div>", 1)
const _hoisted_17 = { class: "about-this-web" }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("About this web site")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("footer", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("h4", null, [
            _createVNode(_component_router_link, { to: {
                name: 'home',
              } }, {
              default: _withCtx(() => [
                _hoisted_5
              ]),
              _: 1
            })
          ]),
          _hoisted_6
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("h4", null, [
            _createVNode(_component_router_link, { to: {
                name: 'about',
              } }, {
              default: _withCtx(() => [
                _hoisted_8
              ]),
              _: 1
            })
          ]),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: {
                  name: 'about',
                  hash: '#uber-sheep',
                } }, {
                default: _withCtx(() => [
                  _hoisted_9
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: {
                  name: 'about',
                  hash: '#owner',
                } }, {
                default: _withCtx(() => [
                  _hoisted_10
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createElementVNode("h4", null, [
            _createVNode(_component_router_link, { to: {
                name: 'music',
              } }, {
              default: _withCtx(() => [
                _hoisted_12
              ]),
              _: 1
            })
          ]),
          _createElementVNode("ul", null, [
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: {
                  name: 'music',
                  hash: '#original-songs',
                } }, {
                default: _withCtx(() => [
                  _hoisted_13
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: {
                  name: 'music',
                  hash: '#original-mini-songs',
                } }, {
                default: _withCtx(() => [
                  _hoisted_14
                ]),
                _: 1
              })
            ]),
            _createElementVNode("li", null, [
              _createVNode(_component_router_link, { to: {
                  name: 'music',
                  hash: '#cover-songs',
                } }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _hoisted_16
      ])
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_component_router_link, { to: {
          name: 'site',
        } }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      })
    ])
  ]))
}